(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('ccsTrApp')
        .constant('VERSION', "0.5.230 -RELEASE")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
